import React from 'react';
import { Grid } from '@mui/material';
import Input from 'components/Input';
import Dropdown from 'components/Dropdown';
import InputMask from 'components/InputMask';
import { dropStatusMl, dropLogisticaMl, dropListagemMl } from 'utils/drops';

const Filter = ({ grid, control, drops }) => {
  const checkDisplay = (name) => {
    const column = grid?.colunas?.find((c) => c?.field === name);
    if (column?.filterable) {
      return true;
    }
    return false;
  };

  return (
    <Grid container spacing={2}>
      {checkDisplay('id') && (
        <Grid item xs={12}>
          <Input name="id" control={control} label="ID" type="number" />
        </Grid>
      )}
      {checkDisplay('titulo') && (
        <Grid item xs={12}>
          <Input name="titulo" control={control} label="Título" />
        </Grid>
      )}
      {checkDisplay('descricao') && (
        <Grid item xs={12}>
          <Input name="descricao" control={control} label="Produto" />
        </Grid>
      )}
      {checkDisplay('loja') && (
        <Grid item xs={12}>
          <Dropdown
            name="loja"
            control={control}
            label="Loja"
            options={drops?.IntegraAccess?.filter(
              (a) => a?.label === 'MERCADO LIVRE'
            )}
            multiple
          />
        </Grid>
      )}
      {checkDisplay('status') && (
        <Grid item xs={12}>
          <Dropdown
            name="status"
            control={control}
            label="Status"
            options={dropStatusMl}
            multiple
          />
        </Grid>
      )}
      {checkDisplay('estoque') && (
        <Grid item xs={12}>
          <InputMask name="estoque" control={control} label="Estoque" />
        </Grid>
      )}
      {checkDisplay('vendas') && (
        <Grid item xs={12}>
          <InputMask name="vendas" control={control} label="Vendas" />
        </Grid>
      )}
      {checkDisplay('sku') && (
        <Grid item xs={12}>
          <Input name="sku" control={control} label="SKU" />
        </Grid>
      )}
      {checkDisplay('logistica') && (
        <Grid item xs={12}>
          <Dropdown
            name="logistica"
            control={control}
            label="Logística"
            options={dropLogisticaMl}
            multiple
          />
        </Grid>
      )}
      {checkDisplay('listagem') && (
        <Grid item xs={12}>
          <Dropdown
            name="listagem"
            control={control}
            label="Tipo de Anúncio"
            options={dropListagemMl}
            multiple
          />
        </Grid>
      )}
    </Grid>
  );
};

export default Filter;
